import { render, staticRenderFns } from "./VideoCardOverlay.vue?vue&type=template&id=573546d0&"
import script from "./VideoCardOverlay.vue?vue&type=script&lang=ts&"
export * from "./VideoCardOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports